<template>
  <div class="upload-image">
    <IconButton @click="clickFileUpload" icon="image" icon-type="far" />
    <input
      ref="file"
      data-cy="file-input"
      class="upload-image__file-input"
      type="file"
      accept="image/png, image/jpeg"
      multiple
      @change="emitChange"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import IconButton from "@/components/IconButton.vue";

export default defineComponent({
  name: "ChatUploadImage",
  inheritAttrs: false,
  components: {
    IconButton
  },

  setup(props, { emit }) {
    const file = ref<null | HTMLElement>(null);

    function clickFileUpload() {
      if (file.value) {
        file.value.click();
      }
    }

    function emitChange(event: Event) {
      emit("change", event);
    }

    return { file, clickFileUpload, emitChange };
  }
});
</script>

<style lang="scss" scoped>
.upload-image {
  display: flex;
  align-items: center;
  width: 30px; // Size of IconButton
}

.upload-image__file-input {
  visibility: hidden;
  width: 0;
}
</style>
